import React from "react";

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <a href="https://data.bnf.fr/fr/about">À propos</a>
        <a href="https://data.bnf.fr/fr/licence">Informations légales</a>
        <a href="https://data.bnf.fr/fr/warning">Avertissements</a>
        <a href="https://www.bnf.fr/fr/une-question-pensez-sindbad">
          Posez votre question
        </a>
      </div>
    </footer>
  );
}
